import API from '@/api'

export default {
  namespaced: true,

  state: () => ({
    loading: false,
    startDate: null,
    endDate: null,
    group: null,
    lessons: [],
    bells: [],
  }),

  getters: {
    loading(state) {
      return state.loading
    },

    days(state) {
      return _(state.bells)
        .map((x) => x.weekday)
        .uniq()
        .orderBy((x) => x)
        .map((w) => {
          const bells = _(state.bells)
            .filter((x) => x.weekday === w)
            .orderBy((x) => x.lesson)
            .value()

          return {
            weekday: w,
            times: _(bells)
              .map((bell) => ({
                ...bell,
                lessons: state.lessons.filter(
                  (x) => x.weekday === bell.weekday && x.lesson === bell.lesson
                ),
              }))
              .dropRightWhile((x) => !x.lessons.length)
              .value(),
          }
        })
        .value()
    },
  },

  mutations: {
    update(state, { lessons, group, bells, startDate, endDate }) {
      state.group = group
      state.lessons = lessons || []
      state.bells = bells || []
      state.startDate = startDate
      state.endDate = endDate
    },

    updateLoading(state, loading) {
      state.loading = loading
    }
  },

  actions: {
    async fetch({ commit }, data) {
      commit('updateLoading', true)

      const response = await API.getGroupLessons(data)

      commit('update', response)
      commit('updateLoading', false)

      return response
    },
  }
}
